// export function setPersonalCookie() {//フォームにCookieを保存する
// 	const limit = 17280000;//200 days
// 	const personalForm = document.getElementById("pform");
// 	if (!!personalForm) {
// 		personalForm.addEventListener("submit", function(e) {
// 			e.preventDefault();
// 			const allowed = document.getElementById("saveinfo").checked;
// 			const formElements = Array.prototype.slice.call(document.body.querySelectorAll(".savable"));
// 			if (allowed) {//保存する
// 				formElements.forEach(element => {
// 					const val = element.value;
// 					const key = element.name;
// 					if (val) {
// 						const cookieString = `aidaform_${key}=${val};path=/;max-age=${limit};Secure`;
// 						document.cookie = cookieString;
// 						//max-age: Seconds
// 					}
// 				});
// 			} else {//消す
// 				formElements.forEach(element => {
// 					const val = element.value;
// 					const key = element.name;
// 					if (val) {
// 						const cookieString = `aidaform_${key}=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
// 						document.cookie = cookieString;
// 					}
// 				});
// 			}
// 			// personalForm.submit();
// 		}, false)
// 	}
// }

export function getPersonalCookie() {//保存したCookieをフォームに展開する
	const personalForm = document.getElementById("pform");
	if (!!personalForm) {
		const formElements = Array.prototype.slice.call(document.body.querySelectorAll(".savable"));
		if (formElements.length>0) {
			const allCookies = getAllCookiesAsArray();
// console.log("allCookues:",allCookies);
			formElements.forEach(element => {
				const key = element.name;
				if (allCookies[`aidaform_${key}`]!==undefined && element.value==="") {
					element.value = allCookies[`aidaform_${key}`];
				}
				if (element.type==="checkbox" && element.value==allCookies[`aidaform_${key}`]) {
					element.checked = true;
				}
			});
		}
	}
}

export function expandCookie() {//デコードされたcookieをフォームに展開する
	const $cookie = document.getElementById("decoded_cookie");
	const personalForm = document.getElementById("pform");
	if ($cookie && !!personalForm) {
		//データの配列化
		const cookieVal = $cookie.value;
		const cookieArr = cookieVal.split("&");
		const splitArr = [];
		cookieArr.forEach(el => {
			const spl = el.split("=");
			splitArr.push([spl.shift(), spl.join("=")]);
		});
		// console.log("cookie",splitArr);

		//展開
		splitArr.forEach(el => {
			const key = el[0];
			const inputEl = document.getElementsByName(key)[0];
			if (!!inputEl && inputEl.value==="") {
				// console.log("EMP");
				inputEl.value = el[1];
			}
		})
	}

}

// export function setAuthedWithCookie() {//タイムスタンプを保存
// 	const limit = 604800;//7 days
// 	const form = document.getElementById("pform");
// 	if (!!form) {
// 		form.addEventListener("submit", function(e) {
// 			e.preventDefault();
// 			const elStamp = document.getElementsByName("stamp")[0] || [""][0];
// 			const stamp = elStamp.value;
// 			const cookieString = `stamp=${stamp};path=/;max-age=${limit};Secure`;
// 			document.cookie = cookieString;
// 			form.submit();
// 		},false)
// 	}
// }

// export function setAuthedCookie() {//確認済みcookie設定（以前のもの）
// 	const limit = 17280000;//200 days
// 	const expires = (new Date(Date.now() + limit*1000)).toUTCString();
// 	const allCookies = getAllCookiesAsArray();
// 	if (allCookies["aida_applied"]===undefined) {
// 		if (window.location.search!=="") {
// 			const params = window.location.search.split("?")[1].split("&");
// 			const allParams = [];
// 			params.forEach(element => {//パラメーターを配列に展開
// 				const eachParam = element.split("=");
// 				allParams[eachParam[0]] = eachParam[1]
// 			})
// 			const stamp = allParams["stamp"];
// 			if (stamp!==undefined && allCookies["stamp"]===allParams["stamp"]) {
// 				const cookieString = `aida_applied=true;path=/;Expires=${expires};Secure`;
// 				document.cookie = cookieString;
// 			}
// 		}
// 	}
// }

// export function pathThrough() {//確認済みcookie設定 パススルー
// 	const limit = 17776000;//60*60*24*120;//120 days
// 	const expires = (new Date(Date.now() + limit*1000)).toUTCString();
// 	console.log("expires",expires);
// 	const allCookies = getAllCookiesAsArray();
// 	if (allCookies["aida_applied"]===undefined) {
// 		if (window.location.search!=="") {
// 			const allParams = getAllParamsAsArray();
// 			const authkey = allParams["authkey"];
// 			if (authkey!==undefined && authkey==="aidainfosubmitted") {
// 				const cookieString = `aida_applied=true;path=/;Expires=${expires};Secure`;
// 				document.cookie = cookieString;
// 			}
// 		}
// 	}
// }

export function getAuthedCookie() {//cookie確認
	const allCookies = getAllCookiesAsArray();
	const allParams = getAllParamsAsArray();
	console.log(allCookies["aida_applied"]);
	if (allCookies["aida_applied"]==="true" || allParams["authkey"]==="aidainfosubmitted") {
		const locker = Array.prototype.slice.call(document.body.querySelectorAll(".aida_plz_submit"));
		locker.forEach(element => {
			element.remove();
		});
		const lockerThumb = Array.prototype.slice.call(document.body.querySelectorAll("._youtube_thumb"));
		lockerThumb.forEach(element => {
			element.remove();
		});
		const downloadButton = Array.prototype.slice.call(document.body.querySelectorAll("._not_applied"));
		downloadButton.forEach(element => {
			element.classList.remove("_not_applied");
		});
	} else {
		const downloadButton = Array.prototype.slice.call(document.body.querySelectorAll("._not_applied"));
		downloadButton.forEach(element => {
			element.remove();
		});
	}
}

function getAllCookiesAsArray() {
	const storedCookies = document.cookie;
	const allCookies = [];
	if (storedCookies) {
		const cookieArray = storedCookies.split("; ");
		cookieArray.forEach(element => {
			// console.log(element);
			const eachCookie = element.split("=");
			allCookies[eachCookie[0]] = eachCookie[1];
		})
	}
	return allCookies;
}

function getAllParamsAsArray() {
	const params = window.location.search.split("?")[1];
	const allParams = [];
	if (!!params) {
		let splitParams = params;
		if (params.indexOf("&")) {
			splitParams = params.split("&");
		}
		splitParams.forEach(element => {//パラメーターを配列に展開
			const eachParam = element.split("=");
			allParams[eachParam[0]] = eachParam[1]
		})
	}
	return allParams;
}